module.exports = __webpack_public_path__ + "static/media/prev.43468e8e.svg";